import { HStack, HTMLChakraProps, Image, useColorModeValue } from "@chakra-ui/react";
import logoDark from "./logo-dark.svg";
import logoLight from "./logo-light.svg";

type ILogoProps = HTMLChakraProps<"div">;

export function Logo(props: ILogoProps) {
    const logoSrc = useColorModeValue(logoLight, logoDark);

    return (
        <HStack {...props}>
            <Image src={logoSrc} alt="Garrigue Games" w="full" />
        </HStack>
    );
}
